// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Content__wrapper__146fy","container":"Content__container__9myGI","layout":"Content__layout__X9BON"};